<div class="card border-0 p-0">
    <div class="card-body" [ngBusy]="{busy: isBusy, message: ''}">
        <form [formGroup]="viewDetailFrm" id="viewTempLogDetail">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblUnitName">Unit Name</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divUnitName">{{rowData.unitName}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblUnitType">Unit Type</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divUnitType">{{rowData.unitTypeDescr}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblUnitStyle">Unit Style</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divUnitStyle">{{rowData.unitStyleDescr}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblUnitStatus">Unit Status</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divUnitStatus">{{rowData.unitStatusDescr}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblLastStartDate">Last Start Date</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divLastStartDate">{{rowData.dateActivation}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblLastSubmitDate">Last Submit Date</label>
                    <label class="col-form-label font-weight-normal ps-2 text-uppercase" id="divLastSubmitDate">{{rowData.submitionDate}}</label>
                </div>
                <div class="d-flex flex-column  col-auto flex-column flex-md-row">
                    <label for="" class="col-form-label" id="lblCovidVaccineStored"> Will COVID-19 Vaccine be stored in
            this
            Unit?
          </label>
                    <div class="text-uppercase  col-form-label font-weight-normal col-auto ps-2" id="divCovidVaccineStored">
                        {{rowData?.covidVaccineStored === 'Y' ? 'Yes' : 'No'}}</div>
                </div>
            </div>
            <div class="mt-2">
                <p-table [value]="temperatureLogDetailList" [responsive]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th rowspan="2" class="col-auto">Day</th>
                            <th rowspan="2" class="col-auto">Office Status</th>
                            <th colspan="2" class="col-auto text-center">Exact Time of Reading
                            </th>
                            <th colspan="2" class="col-auto text-center">Min Temp</th>
                            <th colspan="2" class="col-auto text-center">Max Temp</th>
                            <th rowspan="2" class="table-medium1-cell-width">Staff Initials / Name</th>
                            <th rowspan="2" class="col-auto">User</th>
                        </tr>
                        <tr>
                            <th class="text-center">Hr</th>
                            <th class="text-center">Min</th>
                            <th class="text-center">&deg;C</th>
                            <th class="text-center">&deg;F</th>
                            <th class="text-center">&deg;C</th>
                            <th class="text-center">&deg;F</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                        <tr>
                            <td><span class="p-column-title">Day</span>{{rowData.date}}</td>
                            <td><span class="p-column-title">Office Status</span>{{rowData.officeStatus}}</td>
                            <td class="text-center"><span class="p-column-title">Hours</span>{{rowData.hour}}</td>
                            <td class="text-center"><span class="p-column-title">Mins</span>{{rowData.minute}}</td>
                            <td [ngClass]="getCssClasses(rowData)" class="text-center">
                                <span class="p-column-title">Min&deg;C</span>{{rowData.minTempInC}}</td>
                            <td [ngClass]="getCssClasses(rowData)" class="text-center">
                                <span class="p-column-title">Min&deg;F</span>{{rowData.minTempInF}}</td>
                            <td [ngClass]="getCssClasses(rowData)" class="text-center">
                                <span class="p-column-title">Max&deg;C</span>{{rowData.maxTempInC}}</td>
                            <td [ngClass]="getCssClasses(rowData)" class="text-center">
                                <span class="p-column-title">Max&deg;F</span>{{rowData.maxTempInF}}</td>
                            <td><span class="p-column-title">Initials</span>{{rowData.staffInitials}}</td>
                            <td><span class="p-column-title">User</span>{{rowData.userName}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="mt-2" *ngIf="viewDetailFrm.controls.prevComments.value.length > 0">
                <div class="d-flex flex-column">
                    <label for="" class="col-form-label" id="lblComments">Comments</label>
                    <textarea class="form-control form-control-sm" id="txtComments" formControlName="prevComments"></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="d-flex justify-content-end">
            <button pRipple type="button" class="btn btn-sm btn-primary" (click)="print()">Print</button>
            <button pRipple type="button" class="btn btn-sm btn-secondary" (click)="cancelDetail()">Cancel</button>
        </div>
    </div>
</div>
